export default "/profile/images/avans-qr.png?4c43ecc25e027ce9adbfab84daeddcaa";